import { render, staticRenderFns } from "./messageUnsubscribe.vue?vue&type=template&id=737cc837&scoped=true&"
import script from "./messageUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./messageUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./messageUnsubscribe.vue?vue&type=style&index=0&id=737cc837&lang=scss&scoped=true&"
import style1 from "./messageUnsubscribe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737cc837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
